import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectFieldOptions,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'
import refundPaymentFilterFormFields from './refund-payment-filter-form-fields'

const propTypes = {
  filterValues      : PropTypes.object.isRequired,
  onClickSubmitForm : PropTypes.func.isRequired,
  onClickReset      : PropTypes.func.isRequired
}

const PaymentMethodFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset
}) => (
  <Formik
    initialValues={{
      refund_number                : filterValues.refund_number || '',
      transaction_no               : filterValues.transaction_no || '',
      customer_bank_holder_name    : filterValues.customer_bank_holder_name || '',
      transfer_method              : filterValues.transfer_method || '',
      status                       : filterValues.status || '',
      customer_bank_name           : filterValues.customer_bank_name || '',
      customer_bank_account_number : filterValues.customer_bank_account_number || '',
      per_page                     : filterValues.perPage || ''
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      ({ isSubmitting }) => (
        <Form>
          <InputField
            type='input'
            name='refund_number'
            label='Order Number'
            placeholder="20012xxxx"
            size={ 'sm' }
          />

          <InputField
            type='input'
            name='transaction_no'
            label='Transaction Number'
            size={ 'sm' }
          />
          <InputField
            type='input'
            name='customer_bank_holder_name'
            label='Bank Holder Name'
            size={ 'sm' }
          />

          <InputField
            type='input'
            name='customer_bank_name'
            label='Bank Name'
            size={ 'sm' }
          />

          <InputField
            type='input'
            name='customer_bank_account_number'
            label='Account Number'
            placeholder="Search with Bank Name"
            size={ 'sm' }
          />

          {
            refundPaymentFilterFormFields.map((filterField) => (
              <InputField
                formGroupClassName={ filterField.formGroupClassName }
                key={ `filter-form-list-${filterField.name}` }
                type={ filterField.type }
                name={ filterField.name }
                label={ filterField.label }
                size={ 'sm' }
              >
                <InputSelectFieldOptions
                  options={ filterField.options }
                />
              </InputField>
            ))
          }

          <LoaderButton
            color='primary'
            className='mt-auto'
            type='submit'
            disabled={ isSubmitting }
            isLoading={ isSubmitting }
            text='Filter'
          />
          <LoaderButton
            color='danger'
            disabled={ isSubmitting }
            isLoading={ isSubmitting }
            text='Reset'
            onClick={ onClickReset }
          />
        </Form>
      )
    }
  </Formik>
)

PaymentMethodFilterForm.propTypes = propTypes

export default PaymentMethodFilterForm
